import { render, staticRenderFns } from "./AttestationAccountsDatatable.vue?vue&type=template&id=d07152c6&scoped=true&"
import script from "./AttestationAccountsDatatable.vue?vue&type=script&lang=js&"
export * from "./AttestationAccountsDatatable.vue?vue&type=script&lang=js&"
import style0 from "./AttestationAccountsDatatable.vue?vue&type=style&index=0&id=d07152c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07152c6",
  null
  
)

export default component.exports